import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroup } from 'primeng/inputgroup';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputText } from 'primeng/inputtext';
import { Textarea } from 'primeng/textarea';
import Media from '../../../../../../types/media/Media';
import { MediaService } from '../../../../services/media.service';

@Component({
    selector: 'app-update-media-dialog',
    templateUrl: './update-media-dialog.component.html',
    styleUrls: [ './update-media-dialog.component.scss' ],
    imports: [
        Dialog,
        IftaLabelModule,
        InputText,
        FormsModule,
        Textarea,
        Button,
        InputGroupAddon,
        InputGroup
    ]
})
export class UpdateMediaDialogComponent implements OnChanges {
    @Input() public visible: boolean = false;
    @Input() public media: Media = new Media({});
    @Output() public mediaUpdated: EventEmitter<Media> = new EventEmitter<Media>();
    @Output() public visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public editableFilename: string = '';
    public fileExtension: string = '';
    private selectedFile: File | null = null;

    constructor(private readonly mediaService: MediaService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['media'] && this.media) {
            this.extractFileExtension();
        }
    }

    private extractFileExtension(): void {
        if (this.media?.filename) {
            const dotIndex = this.media.filename.lastIndexOf('.');
            this.fileExtension = dotIndex > -1 ? this.media.filename.substring(dotIndex) : '';
            this.editableFilename = this.media.filename.replace(this.fileExtension, '');
        } else {
            this.fileExtension = '';
            this.editableFilename = '';
        }
    }

    public save(): void {
        if (this.media) {
            const updatedMedia: Media = { ...this.media };

            if (this.selectedFile) {
                updatedMedia.filename = this.selectedFile.name;
            }

            this.mediaService.updateMedia(this.media.id, updatedMedia).then(
                (response: Media) => {
                    this.mediaUpdated.emit(response);
                    this.closeDialog();
                },
                (error: any) => {
                    console.error('Error updating media:', error);
                }
            );
        }
    }

    public closeDialog(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.selectedFile = null;
    }
}
